import React,{Component} from 'react'
import one from '../images/company_images/logo-01@2x.png'
import two from '../images/company_images/logo-02@2x.png'
import three from '../images/company_images/logo-03@2x.png'
import four from '../images/company_images/logo-04@2x.png'
import five from '../images/company_images/logo-05@2x.png'
import six from '../images/company_images/logo-06@2x.png'
import seven from '../images/company_images/logo-07@2x.png'
import eight from '../images/company_images/logo-08@2x.png'
import nine from '../images/company_images/logo-09@2x.png'
import ten from '../images/company_images/logo-10@2x.png'
import company11 from '../images/company_images/microland.png'
import company12 from '../images/company_images/multiplex.png'
import company13 from '../images/company_images/sharechat.png'
import company14 from '../images/company_images/norwich.png'



export const imageList = [one,two,three,four,five,six,seven,eight,nine,ten,company11,company12,company13,company14];

export default class CompanyLogos extends Component{
    render(){
        return <ul className={'companyList'}>
            <li style={{backgroundImage:`url(${one})`}}></li>
            <li style={{backgroundImage:`url(${two})`}}></li>
            <li style={{backgroundImage:`url(${three})`}}></li>
            <li style={{backgroundImage:`url(${four})`}}></li>
            <li style={{backgroundImage:`url(${five})`}}></li>
            <li style={{backgroundImage:`url(${six})`}}></li>
            <li style={{backgroundImage:`url(${seven})`}}></li>
            <li style={{backgroundImage:`url(${eight})`}}></li>
            <li style={{backgroundImage:`url(${nine})`}}></li>
            <li style={{backgroundImage:`url(${ten})`}}></li>
            <li style={{backgroundImage:`url(${company11})`}}></li>
            <li style={{backgroundImage:`url(${company12})`}}></li>
            <li style={{backgroundImage:`url(${company13})`}}></li>
            <li style={{backgroundImage:`url(${company14})`}}></li>
        </ul>
    }
}


// WEBPACK FOOTER //
// ./src/components/CompanyLogos.js